import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className='py-4'>
      <Link
        to='https://www.youtube.com/@MilkyWay-y2k25'
        target='_blank'
        className='text-gray-500'
      >
        MrMilkyWay <span className='text-blue-500'>@2025</span>
      </Link>
    </footer>
  );
};

export default Footer;
